import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import "./assets/css/bootstrap.css";
import "./assets/css/style.css";
import "./components/global.js";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
if (!container) {
  throw new Error('Root element with id "root" was not found.');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <BrowserRouter>
      <div className="spinner-container d-none" id="loading">
        <div className="loading-spinner"></div>
        <div className="loading-progress d-none" id="loading-progress">
          <div className="loading-progress-track">
            <div className="loading-progress-bar" id="loading-progress-bar"></div>
          </div>
          <div className="loading-progress-text" id="loading-percent"></div>
        </div>
      </div>
      <AppRoutes />
    </BrowserRouter>
  </StrictMode>
);

reportWebVitals();
